module.exports = __webpack_public_path__ + "public/SiteIcons/blackLightMode.svg?c80bedbd";